import React from "react";

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* BACKDROP */}
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
      />

      {/* MODAL */}
      <div className="relative bg-white rounded-xl text-start shadow-lg w-[400px] p-6 z-10 animate-fadeIn">
        <h2 className="text-lg font-semibold text-gray-800 mb-3">
          Delete Folder
        </h2>

        <p className="text-gray-600 mb-6">
          Are you sure you want to delete this folder?
        </p>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg bg-gray-100 hover:bg-gray-200"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            className="px-5 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700"
          >
            Yes Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
